import PictureRight from "../../assets/layouts/pictureRight.jpg";
import PictureLeft from "../../assets/layouts/pictureLeft.jpg";
import Double from "../../assets/layouts/double.jpg";
import DoubleSubtitle from "../../assets/layouts/doubleSubtitle.jpg";
import Normal from "../../assets/layouts/normal.jpg";
import Picture from "../../assets/layouts/picture.jpg";
import Chart from "../../assets/layouts/chart.jpg";
import NormalChart from "../../assets/layouts/normalChart.jpg";
import SubtitleChart from "../../assets/layouts/subtitleChart.jpg";
import Layout from "./Layout.json";

export const getLayoutImage = (layoutType) => {
	switch (layoutType) {
		case Layout.normal:
			return Normal;
		case Layout.double:
			return Double;
		case Layout.doubleSubtitle:
			return DoubleSubtitle;
		case Layout.picture:
			return Picture;
		case Layout.pictureLeft:
			return PictureLeft;
		case Layout.pictureRight:
			return PictureRight;
		case Layout.chart:
			return Chart;
		case Layout.normalChart:
			return NormalChart;
		case Layout.subtitleChart:
			return SubtitleChart;
		default:
			return "";
	}
};
